import { makeStyles } from '@material-ui/core';

export const useIconButtonStyles = makeStyles((theme) => ({
  iconButton: (props) => ({
    textAlign: 'center',
    cursor: 'pointer',
    color: props.color ? props.color : 'initial',
    backgroundColor: props.backgroundColor ? props.backgroundColor : 'initial',
    display: props.display ? props.display : 'initial',
    alignItems: 'center',
    '&:hover': {
      '& svg': {
        transform: 'scale(1.1)',
      },
      color: props.hoverColor ? props.hoverColor : 'initial',
    },
  }),
  text: (props) => ({
    textDecoration: props.underline ? 'underline' : 'initial',
    color: props.textColor ? props.textColor : '#fff',
    fontSize: props.fontSize ? props.fontSize : 'initial',
  }),
}));
